import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  Problems,
  Help,
  Chapters,
  Steps,
  Advance,
  Cost
} from "../../../components/LandingTemplates/uchis_uchitsya_nachalo";

const TITLE = 'Учись учиться. Начало';
const DESCRIPTION = 'Онлайн-курс для детей 6–10 лет и их родителей. Инструменты для успеха в школе и в жизни.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} gcCounter={true}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <div className="container">
      <HeaderLogoAndTel/>
    </div>

    <main style={{ color: "#282828" }}>
      <Screen1/>
      <Problems/>
      <Help/>
      <Chapters/>
      <Steps/>
      <Advance/>
      <Cost
        widgetOtl={<GetCourseWidget hash={'46f77eaf11be713d6e968a245f77e544e28049ba'} id={'1112368'}/>}
        widgetIndi={<GetCourseWidget hash={'a04d395a89c2ab7b34e26e14b898b58d0abf9614'} id={'1112474'}/>}
      />
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
